import React, { useEffect } from "react";

import { useIntl } from "react-intl";

import { EntityTypeSupportingGroups, Group } from "@mapmycustomers/shared/types/entity";
import Team from "@mapmycustomers/shared/types/Team";
import User from "@mapmycustomers/shared/types/User";

import SelectGroupsDialog from "@app/component/SelectEntityDialog/SelectGroupsDialog";
import SelectTeamsDialog from "@app/component/SelectEntityDialog/SelectTeamsDialog";
import SelectUsersDialog from "@app/component/SelectEntityDialog/SelectUsersDialog";
import defaultIdGetter from "@app/util/defaultIdGetter";

import { GroupByType } from "./enum/GroupByType";
import { groupByMessages } from "./messages";
import { GroupByEntity } from "./types/GroupByEntity";
import { entityName } from "./util";

interface Props {
  groupByType: GroupByType;
  list: GroupByEntity[];
  onHide: () => void;
  onUpdateSelectedEntities: (entities: GroupByEntity[]) => void;
  recordTypes: EntityTypeSupportingGroups[];
  selectedEntities: GroupByEntity[];
  visible: boolean;
}

const EntitySelector: React.FC<Props> = ({
  groupByType,
  list,
  onHide,
  onUpdateSelectedEntities,
  selectedEntities,
  visible,
}) => {
  const intl = useIntl();

  useEffect(() => {
    onHide();
  }, [groupByType, onHide]);

  useEffect(() => {
    onUpdateSelectedEntities(list);
  }, [groupByType, onUpdateSelectedEntities, list]);

  if (!visible) {
    return null;
  }
  if (groupByType === GroupByType.USER) {
    return (
      <SelectUsersDialog
        entities={list as User[]}
        getDisplayName={entityName[GroupByType.USER]}
        getKey={defaultIdGetter}
        onConfirm={onUpdateSelectedEntities}
        onHide={onHide}
        selectedEntities={selectedEntities as User[]}
        title={intl.formatMessage(groupByMessages[GroupByType.USER])}
        visible
      />
    );
  } else if (groupByType === GroupByType.TEAM) {
    return (
      <SelectTeamsDialog
        entities={list as Team[]}
        getDisplayName={entityName[GroupByType.TEAM]}
        getKey={defaultIdGetter}
        onConfirm={onUpdateSelectedEntities}
        onHide={onHide}
        selectedEntities={selectedEntities as Team[]}
        title={intl.formatMessage(groupByMessages[GroupByType.TEAM])}
        visible
      />
    );
  } else if (groupByType === GroupByType.GROUP) {
    return (
      <SelectGroupsDialog
        entities={list as Group[]}
        getDisplayName={entityName[GroupByType.GROUP]}
        getKey={defaultIdGetter}
        onConfirm={onUpdateSelectedEntities}
        onHide={onHide}
        selectedEntities={selectedEntities as Group[]}
        title={intl.formatMessage(groupByMessages[GroupByType.GROUP])}
        visible
      />
    );
  }
  return null;
};

export default EntitySelector;
